import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Form,
  Label,
  Spinner,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import { URLS } from "../../Url";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { format } from "date-fns";
import { baseurl, imgUrl } from "Baseurls";

function Ventures() {
  const [form, setform] = useState([])
  const [formss, setformss] = useState([])
  console.log(formss)
  const [show2, setshow2] = useState(false)
  const [show3, setshow3] = useState(false)
  const [show4, setshow4] = useState(false)
  const toggle = () => setshow3(!show3)
  const toggle1 = () => setshow4(!show4)

  const history = useHistory()
  const [form1, setform1] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token
  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  useEffect(() => {
    getAgent()
  }, [])

  const getAgent = () => {
    var token = datas
    axios
      .post(baseurl + 'doctor/getallunblockrequest', {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setform(res.data.unBlockRequests)
        // setIsLoading(false)
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const lists = form.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(form.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const Agentid = (data) => {
    sessionStorage.setItem("docid", data.doctorObjId)
    history.push("/ViewUser")
  }

  const Search = (e) => {
    const myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)

    const token = datas
    console.log(token)

    axios
      .post(baseurl + 'doctor/getallunblockrequest?searchQuery=' + e.target.value, {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setform(res.data.unBlockRequests)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            // toast(error.response.data.message)
          }
        }
      )
  }

  const Viewpopup = (data) => {
    setformss(data)
    setshow3(true)
  }


  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  // const roles = data.rolesAndPermissions
  // const roles1 = data.user.role

  const [datastate, setDatastate] = useState([])

  let dates = [];

  const handleDateChange = (NewDate) => {
    console.log(NewDate[0]);

    const date1 = format(new Date(NewDate[0]), "yyyy-MM-dd");
    const date2 = format(new Date(NewDate[1]), "yyyy-MM-dd");
    dates.push(date1);
    dates.push(date2);
    setDatastate(dates);
  };

  const BlockDoctor = (e) => {
    e.preventDefault()
    var token = datas
    const bodydata = {
      status: true,
      blockedReason: "",
    }
    axios
      .post(baseurl + 'doctor/releaseblockedrequest/' + formss._id, bodydata, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast.success(res.data.message)
            setshow3(false)
            getAgent()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast.error(error.response.data.message)
          }
        }
      )
  }



  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Allude" breadcrumbItem="Release Request's" />

          {show2 == true ? (
            <Card className="p-4">
              <Form
                onSubmit={(e) => {
                  filterCustomer(e)
                }}
              >
                <Row>
                  <Col md="3">
                    <div className="mb-4">
                      <Label>Date Range</Label>

                      <Flatpickr
                        required
                        className="form-control d-block"
                        placeholder="dd M,yyyy"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                        }}
                        name="date"
                        // value={selectedDate}
                        onChange={(e) => { handleDateChange(e) }}
                      />
                    </div>
                  </Col>


                  <Col md="3">
                    <div className="text-end mt-4">
                      <Button type="submit" color="success m-1" outline>
                        Submit <i className="bx bx-check-circle"></i>
                      </Button>
                      <Button
                        type="button"
                        onClick={() => {
                          setshow2(!show2)
                        }}
                        color="danger m-1"
                        outline
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Card>
          ) : (
            ""
          )}

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="6">
                    </Col>
                    <Col md="6">

                      <div style={{ float: "right" }}>
                        <Input
                          name="search"
                          value={form1.search}
                          onChange={(e) => { Search(e) }}
                          type="search"
                          placeholder="Search..."
                        />
                      </div>
                      {/* <Button style={{ float: "right", marginRight: "10px", marginLeft: "10px" }} onClick={() => { setshow2(!show2) }} color="warning">
                        Filter <i className="bx bx-filter-alt"></i>
                      </Button>
                      <div className="text-end mt-2">
                        <b>Users Count: 01</b>
                      </div> */}
                    </Col>
                  </Row>

                  <div className="table-rep-plugin table-responsive">
                    <Table hover className="table table-bordered mb-4 mt-2">
                      <thead>
                        <tr className="text-center">
                          <th>Sl No</th>
                          <th>Date</th>
                          <th>Doctor & User Id</th>
                          <th>Name</th>
                          <th>Reason</th>
                          {/* <th>Replay</th> */}
                          <th>File</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.length == 0 ? (
                          <tr className="text-center">
                            <td colSpan={7}>No Data...</td>
                          </tr>
                        ) : (
                          <>
                            {lists.map((data, key) => (
                              <tr className="text-center" key={key}>
                                <th>{(pageNumber - 1) * 5 + key + 6}</th>
                                <td>{data.date}</td>
                                <td>
                                  <a className="text-primary" onClick={() => { Agentid(data) }}>{data.doctorId} </a>
                                </td>
                                <td>{data.name}</td>
                                {/* <td>{data.name}</td> */}
                                <td>{data.description}</td>
                                <td>
                                  <img src={imgUrl + data.image} style={{ width: "50px" }} />
                                </td>
                                <td>
                                  {/* <Link to="/ViewUser">
                                <Button
                                  size="sm"
                                  className="m-1"
                                  outline
                                  color="warning"
                                >
                                  <i
                                    style={{ fontSize: " 14px" }}
                                    className="fas fa-eye"
                                  ></i> View
                                </Button>
                              </Link> */}
                                  <Button
                                    onClick={() => { Viewpopup(data) }}
                                    size="sm"
                                    className="m-1"
                                    outline
                                    color="success"
                                    title="Release"
                                  >
                                    <i
                                      className="bx bx-shuffle"
                                    ></i> Release
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </>
                        )}

                      </tbody>
                    </Table>
                    <div
                      className="d-flex mt-3 mb-1"
                      style={{ float: "right" }}
                    >
                      <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={changePage}
                        containerClassName={"pagination"}
                        previousLinkClassName={"previousBttn"}
                        nextLinkClassName={"nextBttn"}
                        disabledClassName={"disabled"}
                        activeClassName={"active"}
                        total={lists.length}
                      />
                    </div>
                  </div>
                  {/* </>
                  )} */}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal isOpen={show3} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>User Block</ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  BlockDoctor(e)
                }}
              >

                <div className="text-center mt-3 mb-4">
                  <div>
                    <i style={{ fontSize: "100px" }} className="bx bx-info-circle text-warning" />
                    <h3>Do you want to unblock this user.</h3>
                  </div>
                </div>

                <div className="text-center">
                  <Button
                    type="button"
                    onClick={() => {
                      setshow3(!show3)
                    }}
                    style={{ width: "100px" }}
                    color="danger m-1"
                    outline
                  >
                    Cancel <i className="bx bx-x-circle"></i>
                  </Button>
                  <Button style={{ width: "100px" }} type="submit" color="success m-1" outline>
                    Yes <i className="bx bx-check-circle"></i>
                  </Button>
                </div>
              </Form>
            </ModalBody>
          </Modal>

          <Modal isOpen={show4} toggle={toggle1} centered>
            <ModalHeader toggle={toggle1}>Info</ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  formeditsubmit(e)
                }}
              >

                <div className=" mb-4">
                  <div className="border-bottom">
                    <b>Blocked Reason</b>
                    <p>Your miss use our application</p>
                  </div>
                  <div className="mt-3">
                    <h4>User Replay</h4>
                    <b>Message</b>
                    <p>Sorry, it won't happen again. Please give me access</p>
                  </div>
                </div>

                <div className="text-end">
                  <Button
                    type="button"
                    onClick={() => {
                      setshow4(!show4)
                    }}
                    style={{ width: "100px" }}
                    color="danger m-1"
                    outline
                  >
                    Cancel <i className="bx bx-x-circle"></i>
                  </Button>
                  {/* <Button style={{width:"100px"}} type="submit" color="success m-1" outline>
                    Yes <i className="bx bx-check-circle"></i>
                  </Button> */}
                </div>
              </Form>
            </ModalBody>
          </Modal>

          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
